import { ImageChip } from 'components/Chip/ImageChip';
import { pureComponent } from 'lib/pureComponent';
import React, { useCallback, useState } from 'react';
import { LayoutChangeEvent, StyleSheet, View } from 'react-native';
import { APIRemoteUrl } from 'service/api/constants';

interface Props {
  ids: string[];
  onRemove?: (id: string) => void;
  onPreview?: (fileId: string) => void;
  onDownload?: (fileId: string) => void;
  previewOnPress?: boolean;
  remoteUrl?: APIRemoteUrl;
}

export const ImageGrid: React.FC<Props> = pureComponent(
  ({ ids, onRemove, onPreview, onDownload, previewOnPress, remoteUrl }) => {
    const [tileWidth, setTileWidth] = useState({ perRow: 1, width: 130 });

    const handleOnLayout = useCallback(({ nativeEvent }: LayoutChangeEvent) => {
      const width = nativeEvent.layout.width - 25;
      const idealWidth = 100;
      const numberOfTilesInRow = Math.floor(width / idealWidth);
      setTileWidth({
        perRow: numberOfTilesInRow,
        width: width / numberOfTilesInRow - 2,
      });
    }, []);

    return (
      <View style={styles.chips} onLayout={handleOnLayout}>
        {ids.map((id) => (
          <View
            key={id}
            style={{
              width: tileWidth.width,
              height: tileWidth.width,
              margin: 1,
              borderRadius: 6,
              overflow: 'hidden',
            }}
          >
            <ImageChip
              key={id}
              fileId={id}
              onRemove={onRemove}
              onPreview={onPreview}
              onDownload={onDownload}
              previewOnPress={previewOnPress}
              remoteUrl={remoteUrl}
            />
          </View>
        ))}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  chips: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: -25,
  },
});
